import getConfig from 'next/config';
import { withRouter } from 'next/router';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button } from '@bijie/react-bnb';
import is from 'is_js';
import { Router, Link } from '../../routes';
import { getLocales, getSupportLocale } from '../../utils/locales';
import withI18n from '../../utils/withI18n';
import { eraseCookie, createCookie, readCookie } from '../../utils/cookies-browser';
import zIndexScale from '../../utils/zIndexScale';
import Logout from '../../actions/actionsSet/authcenter';
import { getLabel } from '../../utils/i18n';
import { getInfoBase, getLoginUrl } from '../../utils/urlUtils';

import { track, sensorEventTypes } from '../../utils/sensors';
import urlConfig, { getSupportUrl } from '../../config/urls';
import { getUserBtcValuation } from '../../actions/actionsSet/assetService';

import FlexBox from '../FlexBox';
import Logo from '../Logo';
import { NavLi, NavList, NavListItem } from '../Nav';
import Dropdown from '../Dropdown';
import DropdownGoogleTran from '../DropdownGoogleTran';
import Icon from '../Icon';
import UserInfoPanel from './UserInfoPanel';
import UserAvatar from '../UserCenter/UserBaseInfo/UserAvatar';
import { getNativeCurrency } from '../FiatRateSwitch';
import RateLists from '../FiatRateSwitch/RateLists';
import RateIcon from '../FiatRateSwitch/RateIcon';

import feature from '../../config/feature';
// import navs from '../../config/navs';

const { VIEW_INFO, GOOGLE_TRANSLATOR_DOWN } = sensorEventTypes;

let CHAT_SHOW_FLAG = true;

const {
  publicRuntimeConfig: {
    registerUrl: REGISTER_URL,
    routePrefix: ROUTE_PREFIX,
    basicTradeUrl: BASIC_TRADE_URL,
    advancedTradeUrl: ADVANCED_TRADE_URL,
  },
} = getConfig();

const { enableRegister: ENABLE_REGISTER } = feature;

const {
  external: { careers: CAREERS_URL, support: SUPPORT_URL, announcements: ANNOUNCEMENTS_URL },
  wallet: {
    balances: BALANCES_URL,
    deposit: DEPOSIT_URL,
    withdraw: WITHDRAW_URL,
    depositWithdrawHistory: DEPOSIT_WITHDRAW_URL,
    distributionHistory: DISTRIBUTION_HISTORY_URL,
  },
  site: { about: ABOUT_URL, applyToList: APPLYTOLIST_URL, community: COMMUNITY_URL },
  // user: { creditcard: CREDITCARD_URL },
} = urlConfig;

const LOCALES = getLocales();
const LOCALES_KEYS = Object.keys(LOCALES);

const prefixLink = uri => ROUTE_PREFIX + uri;

/* eslint-disable import/no-unresolved */
const StyledHeader = styled(FlexBox)`
  ${({ showScaleAnimation }) => (showScaleAnimation ? 'position: fixed;' : null)}
  ${({ isHideHeadLangSeclet, scrollScale }) => !isHideHeadLangSeclet && !scrollScale ? 'top:50px;' : null}
  width: 100%;
  z-index: 200;
  font-size: 13px;
  white-space: nowrap;
  user-select: none;
  font-family: ${({ theme }) => theme.fontIBMMedium};
`.withComponent('header');
/* eslint-enable import/no-unresolved */

const HeaderNav = styled(FlexBox)`
  line-height: 1.75;
  .oldSite {
    box-sizing: content-box;
    line-height: 60px;
    font-size: 14px;
    color: rgba(240, 185, 11, 1);
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const HeaderNavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: auto;
  /* padding: 0 10px; */
  width: 100%;
  min-height: 60px;
  background: rgba(11, 14, 17, 0.96);
  transition: all 0.5s;
  padding: 0 30px 0 20px;
`;

export const SelectedLocale = styled(FlexBox)`
  color: #fff;
  justify-content: space-between;
  width: 100%;
  .iconfont {
    margin-right: 4px;
  }
`;

const PopUpListItem = styled(NavListItem)`
  a {
    line-height: 48px;
  }
`;

const LocaleListItem = styled(PopUpListItem)`
  box-sizing: border-box;
  flex: 1 0 50%;
  max-width: 50%;
  width: 50%;
  & > a {
    position: relative;
    /* border-bottom: 1px solid #262626; */
    padding-left: 25px;
    &.selected {
      padding-left: 28px;
    }
    & .iconfont {
      margin-right: 8px;
      position: absolute;
      left: 5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &:nth-child(odd) {
    border-right: 1px solid #262626;
    &:last-child {
      margin-right: auto;
    }
  }
`;

export const HeaderNavItem = styled(NavLi).attrs(() => ({
  role: 'menuitem',
}))`
  position: relative;
  align-items: center;
  & > * {
    padding: 0 16px;
    line-height: 100%;
  }
  .currency {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    max-height: 24px;
    padding: 0 10px 0 5px;
    i {
      transform: scale(0.6);
    }
  }
  &:hover:not(.logo-item) {
    background-color: transparent;
    cursor: pointer;
    & > div:first-child > img,
    span img {
      opacity: 0.6;
      transition: opacity 0.5s;
    }
    .currency {
      a,
      i {
        opacity: 0.6;
        transition: opacity 0.5s;
      }
    }
  }
  & > .iconfont {
    color: #fff;
  }
  min-height: 60px;
  @media screen and (max-width: 1366px) {
    > a {
      padding: 0 10px;
    }
  }
`;

const HeaderNavItemCurrency = styled(HeaderNavItem)`
  margin-left: 16px;
`;

// TODO: crap, fix
export const HeadLink = styled.a`
  opacity: 1;
  margin-right: 5px;
  color: #fff !important;
  &:hover,
  &:active {
    opacity: 0.6;
    transition: opacity 0.5s;
  }
`;

export const ImgArrow = styled.img`
  opacity: 1;
`;

const HeaderNavItemScale = styled(HeaderNavItem)`
  transform-origin: 10px 20px;
  transition: all 0.5s;
  & > * {
    padding: 0 45px 0 16px;
  }
`;

const LoggedInUser = styled(SelectedLocale)`
  > div {
    color: #fff;
  }
  .bnc-avatar {
    line-height: 36px;
    transition: all 0.3s ease-in-out;
    :hover {
      opacity: 0.6;
    }
  }
`;

const ModeList = styled(NavList)`
  display: flex;
  left: 0;
  background-color: #1e2126;
  top: 60px;
  /* border-radius: 4px; */
  @supports (-ms-scroll-limit: 0) {
    /* bad */
    height: 70px;
  }
  &.scroll {
    animation: fadenum 0.25s;
  }
`;

const LocaleList = styled(ModeList)`
  left: auto;
  right: 0;
  width: 250px;
  @supports (-ms-scroll-limit: 0) {
    /* bad */
    height: ${Math.round(LOCALES_KEYS.length / 2) * 35}px;
  }
`;

const LocaleListDown = styled(ModeList)`
  left: auto;
  right: 0;
  top: auto;
  top: calc(100% + 1px);
  width: 250px;
  @supports (-ms-scroll-limit: 0) {
    /* bad */
    height: ${Math.round(LOCALES_KEYS.length / 2) * 35}px;
  }
`;

const LocaleListUp = styled(ModeList)`
  left: auto;
  right: 0;
  top: auto;
  bottom: calc(100% + 1px);
  width: 250px;
  @supports (-ms-scroll-limit: 0) {
    /* bad */
    height: ${Math.round(LOCALES_KEYS.length / 2) * 35}px;
  }
`;

const NavLiLogin = styled(NavLi)`
  margin-left: 0 !important;
  align-items: center;
`;

const UserMenuList = styled(LocaleList)`
  width: auto;
`;

const HeaderMenuList = styled(LocaleList)`
  width: fit-content;
  left: 0;
`;

const HeaderRateList = styled(LocaleList)`
  width: 360px;
  right: 0;
`;

const NavsBox = styled(FlexBox)`
  background: #1e2126;
  padding: 4px 0;
`;

const NavsItem = styled.a`
  display: flex;
  align-items: center;
  padding: 0 15px;
  line-height: 100%;
  width: 100%;
  :hover,
  :visited,
  :focus {
    background: rgba(255, 255, 255, 0.04);
    outline: none;
    text-decoration: none;
  }
  :hover [role='title'] {
    color: ${({ theme }) => theme.highlight};
  }
`;

const NavsItemTitle = styled.span.attrs(() => ({
  role: 'title',
}))`
  font-size: 13px;
  color: ${({ theme }) => theme.fontColor4};
  margin: 2px 0 5px;
  line-height: 100%;
`;

const NavsItemDesc = styled.p`
  font-size: ${({ theme }) => theme.fontSizeSm};
  color: ${({ theme }) => theme.fontColor2};
  line-height: 100%;
`;

const NavsIconWrap = styled(FlexBox)`
  width: 40px;
  height: 40px;
  border-radius: 15px;
  background-color: rgba(240, 185, 11, 0.1);
`;

const NavsIconWrap2 = styled(NavsIconWrap)`
  background-color: rgba(50, 116, 186, 0.1);
`;

const NavsList = styled(ModeList)`
  border: none;
`;

const ModeListItem = styled(PopUpListItem)`
  display: block;
  flex: 1;
  & a:hover {
    color: ${({ theme }) => theme.highlight};
  }
  & a.userInfo {
    position: relative;
    display: block;
    line-height: 18px;
    padding: 7px 16px;
    padding-right: 28px;
    & .iconfont {
      position: absolute;
      right: 6px;
      top: 50%;
      transform: translateY(-50%);
      display: none;
    }
    & strong,
    :hover strong {
      color: #fff;
    }
    & span,
    :hover span {
      color: #999;
    }
    :hover .iconfont {
      display: block;
    }
  }
`;

export const GoogleTranslateBox = styled.div`
  display: ${({ isShow }) => (isShow ? 'block' : 'none')};
  padding: 16px 18px;
  width: 300px;
  height: auto;
  background: #333;
  color: ${({ theme }) => theme.fontColor4};
  position: absolute;
  right: 0px;
  top: 48px;
  z-index: ${zIndexScale.googleTranslateBox};
  box-shadow: ${({ theme }) => theme.boxShadow};
  > h3 {
    font-size: 14px;
    margin-bottom: 15px;
  }
  > p {
    font-size: 12px;
    line-height: 1.5;
    padding-top: 12px;
    margin-top: 12px;
    border-top: 1px solid #262626;
  }
`;

const RelativeHeaderNavItem = styled(HeaderNavItem)`
  position: relative;
`;

const HeaderPrimaryButton = styled(Button)`
  height: 26px !important;
  line-height: 26px;
  padding: 0 10px !important;
  margin-left: 14px;
`;

const sharedPropTypes = {
  i18n: PropTypes.object,
  locale: PropTypes.string,
  hide: PropTypes.bool.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  getLocaleLink: PropTypes.func,
  isLoggedIn: PropTypes.bool,
};

const defaultProps = {
  i18n: {},
  locale: 'en',
  getLocaleLink: () => {},
};

const _onLocaleItemClick = (props, _locale = 'en') => ev => {
  ev.preventDefault();
  ev.stopPropagation();

  if (typeof window !== 'undefined') {
    // set chat lang
    window.localStorage.setItem('chatLang', _locale);
  }

  if (props.onChange) {
    props.onChange(_locale);
    return;
  }
  const href = props.getLocaleLink(_locale);
  eraseCookie('lang');
  createCookie('lang', _locale.toUpperCase());
  Router.replaceRoute(href);
};

const onInfoClick = () => {
  track(VIEW_INFO, {
    source: 'header',
  });
};
export const LocaleMenuUp = ({ locales, className, ...props }) => {
  const keys = Object.keys(locales);
  return (
    <DropdownGoogleTran
      component={
        props.isBottomPoistion ? LocaleListDown : LocaleListUp
      }
      keys={keys}
      className={!props.hide && 'scroll'}
      isOpen={!props.hide}
      onMouseLeave={props.onMouseLeave}
      {...props}
    >
      {({ key: _locale, index }) => (
        <LocaleListItem key={_locale}>
          <a
            href={props.getLocaleLink(_locale)}
            onClick={_onLocaleItemClick(props, _locale)}
            onKeyPress={_onLocaleItemClick(props, _locale)}
            className={props.locale === _locale ? 'selected' : ''}
            role="button"
            tabIndex={index}
          >
            {locales[_locale]}
          </a>
        </LocaleListItem>
      )}
    </DropdownGoogleTran>
  );
};
LocaleMenuUp.propTypes = {
  ...sharedPropTypes,
  locales: PropTypes.object,
};
LocaleMenuUp.defaultProps = {
  ...defaultProps,
  locales: {},
};

/* eslint-disable no-nested-ternary */
const ModeMenu = props => (
  <Dropdown
    component={HeaderMenuList}
    className={!props.hide && 'scroll'}
    keys={['trade', 'tradedetail']}
    isOpen={!props.hide}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    {({ key, index }) => (
      <ModeListItem key={key}>
        {index === 0 ? (
          <Link
            route={BASIC_TRADE_URL.replace('%locale', props.locale).replace(
              '%pair',
              props.selectedPair
            )}
            prefetch={true}
          >
            <a id="exchange-header-trade">{getLabel('exchange-header-Basic', props.i18n)}</a>
          </Link>
        ) : (
          <Link
            route={ADVANCED_TRADE_URL.replace('%locale', props.locale).replace(
              '%pair',
              props.selectedPair
            )}
            prefetch={true}
          >
            <a id="exchange-header-tradePro">{getLabel('exchange-header-Advanced', props.i18n)}</a>
          </Link>
        )}
      </ModeListItem>
    )}
  </Dropdown>
);
/* eslint-enable no-nested-ternary */

ModeMenu.propTypes = {
  ...sharedPropTypes,
  selectedPair: PropTypes.string,
};
ModeMenu.defaultProps = {
  ...defaultProps,
  selectedPair: 'BTC_USDT',
};

const UserMenu = props => (
  <Dropdown
    component={UserMenuList}
    isOpen={!props.hide}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    <UserInfoPanel logout={props.logout} />
  </Dropdown>
);

UserMenu.propTypes = {
  ...sharedPropTypes,
  logout: PropTypes.func,
};
UserMenu.defaultProps = {
  ...defaultProps,
  logout: () => {},
};

const SupportMenu = props => (
  <Dropdown
    component={HeaderMenuList}
    isOpen={!props.hide}
    className={!props.hide && 'scroll'}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    <ModeListItem>
      <Link route={`/${props.locale}/support-center`}>
        <a id="exchange-header-supportCenter">
          {getLabel('exchange-footer-SupportCenter', props.i18n)}
        </a>
      </Link>
      <a
        id="exchange-header-supportSubmit"
        href={`${getSupportUrl(
          SUPPORT_URL.replace('%locale', getSupportLocale(props.locale)),
          props.isLoggedIn
        )}/requests/new`}
      >
        {getLabel('exchange-header-supportSubmit', props.i18n)}
      </a>
      <a
        id="exchange-header-faq"
        href={`${getSupportUrl(
          SUPPORT_URL.replace('%locale', getSupportLocale(props.locale)),
          props.isLoggedIn
        )}/categories/115000056052-FAQ`}
      >
        {getLabel('exchange-header-FAQ', props.i18n)}
      </a>
      <Link route={`/${props.locale}/download`}>
        <a id="exchange-header-download">{getLabel('exchange-header-Download', props.i18n)}</a>
      </Link>
      <a
        id="exchange-header-apiDocuments"
        rel="noopener noreferrer"
        href="https://github.com/binance-exchange/binance-official-api-docs"
      >
        {getLabel('exchange-header-APIDocuments', props.i18n)}
      </a>
    </ModeListItem>
  </Dropdown>
);

SupportMenu.propTypes = sharedPropTypes;
SupportMenu.defaultProps = defaultProps;

const MoreMenu = props => (
  <Dropdown
    component={HeaderMenuList}
    isOpen={!props.hide}
    className={!props.hide && 'scroll'}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    <ModeListItem>
      <a
        id="exchange-footer-Announcement"
        href={getSupportUrl(ANNOUNCEMENTS_URL.replace('%locale', props.locale), props.isLoggedIn)}
      >
        {getLabel('exchange-footer-Announcement', props.i18n)}
      </a>
      <a
        href={CAREERS_URL.replace('%locale', props.locale)}
        target="_blank"
        rel="noopener noreferrer"
        id="exchange-header-career"
      >
        {getLabel('exchange-header-Career', props.i18n)}
      </a>
      <a
        href={ABOUT_URL.replace('%locale', props.locale)}
        target="_blank"
        rel="noopener noreferrer"
        id="exchange-header-aboutUs"
      >
        {getLabel('exchange-header-aboutUs', props.i18n)}
      </a>
      <a
        href={
          readCookie('logined') === 'y'
            ? APPLYTOLIST_URL.replace('%locale', props.locale)
            : `/${props.locale}/login`
        }
        target="_blank"
        rel="noopener noreferrer"
        id="exchange-header-applyToList"
      >
        {getLabel('exchange-header-applyToList', props.i18n)}
      </a>
      <a
        href={COMMUNITY_URL.replace('%locale', props.locale)}
        target="_blank"
        rel="noopener noreferrer"
        id="exchange-header-community"
      >
        {getLabel('exchange-header-Community', props.i18n)}
      </a>
      <Link route={`/${props.locale}/bnb`}>
        <a id="exchange-header-binanceCoin">
          {getLabel('exchange-header-binanceCoin', props.i18n)}
        </a>
      </Link>
    </ModeListItem>
  </Dropdown>
);

MoreMenu.propTypes = sharedPropTypes;
MoreMenu.defaultProps = defaultProps;

const WalletMenu = props => (
  <Dropdown
    component={HeaderMenuList}
    isOpen={!props.hide}
    className={!props.hide && 'scroll'}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    <ModeListItem>
      <a
        href={BALANCES_URL.replace('%locale', props.locale)}
        target="_self"
        rel="noopener noreferrer"
        id="exchange-nav-balances"
      >
        {getLabel('exchange-nav-balances', props.i18n)}
      </a>
      <a
        href={DEPOSIT_URL.replace('%locale', props.locale)}
        target="_self"
        rel="noopener noreferrer"
        id="exchange-nav-deposit"
      >
        {getLabel('exchange-nav-deposit', props.i18n)}
      </a>
      <a
        href={WITHDRAW_URL.replace('%locale', props.locale)}
        target="_self"
        rel="noopener noreferrer"
        id="exchange-nav-withdraw"
      >
        {getLabel('exchange-nav-withdraw', props.i18n)}
      </a>
      <a
        href={DEPOSIT_WITHDRAW_URL.replace('%locale', props.locale)}
        target="_self"
        rel="noopener noreferrer"
        id="exchange-nav-depositWithdrawHistory"
      >
        {getLabel('exchange-nav-depositWithdrawHistory', props.i18n)}
      </a>
      <a
        href={DISTRIBUTION_HISTORY_URL.replace('%locale', props.locale)}
        target="_self"
        rel="noopener noreferrer"
        id="exchange-nav-distributionHistory"
      >
        {getLabel('exchange-nav-distributionHistory', props.i18n)}
      </a>
    </ModeListItem>
  </Dropdown>
);

WalletMenu.propTypes = sharedPropTypes;
WalletMenu.defaultProps = defaultProps;

const USDMenu = props => (
  <Dropdown
    component={HeaderRateList}
    isOpen={!props.hide}
    className={!props.hide && 'scroll'}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    <RateLists />
  </Dropdown>
);

USDMenu.propTypes = sharedPropTypes;
USDMenu.defaultProps = defaultProps;

const LeftMenu = props => (
  <Dropdown
    component={NavsList}
    className={!props.hide && 'scroll'}
    isOpen={!props.hide}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    <NavsBox>
      <Link
        route={BASIC_TRADE_URL.replace('%locale', props.locale).replace(
          '%pair',
          props.selectedPair
        )}
        prefetch={true}
      >
        <NavsItem id="exchange-header-exchange">
          <NavsIconWrap justify="center" align="center" padding="0 0 0 8px">
            <Icon type="exchange" size={24} color="#F0B90B" />
          </NavsIconWrap>
          <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
            <NavsItemTitle>Exchange</NavsItemTitle>
            <NavsItemDesc>{getLabel('exchange-header-assetExchange', props.i18n)}</NavsItemDesc>
          </FlexBox>
        </NavsItem>
      </Link>

      <NavsItem id="exchange-header-education" target="_blank" href="https://www.binance.vision">
        <NavsIconWrap justify="center" align="center">
          <Icon type="academy" size={24} color="#F0B90B" />
        </NavsIconWrap>
        <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
          <NavsItemTitle>Academy</NavsItemTitle>
          <NavsItemDesc>{getLabel('exchange-header-education', props.i18n)}</NavsItemDesc>
        </FlexBox>
      </NavsItem>

      <NavsItem id="exchange-header-bcf" target="_blank" href="https://www.binance.charity">
        <NavsIconWrap justify="center" align="center">
          <Icon type="bcf" size={24} color="#F0B90B" />
        </NavsIconWrap>
        <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
          <NavsItemTitle>BCF</NavsItemTitle>
          <NavsItemDesc>{getLabel('exchange-header-BCF', props.i18n)}</NavsItemDesc>
        </FlexBox>
      </NavsItem>

      <NavsItem
        id="exchange-header-info"
        onClick={onInfoClick}
        target="_blank"
        href={getInfoBase()}
      >
        <NavsIconWrap justify="center" align="center">
          <Icon type="info" size={24} color="#F0B90B" />
        </NavsIconWrap>
        <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
          <NavsItemTitle>Info</NavsItemTitle>
          <NavsItemDesc>{getLabel('exchange-header-Info', props.i18n)}</NavsItemDesc>
        </FlexBox>
      </NavsItem>

      <NavsItem id="exchange-header-labs" target="_blank" href="https://labs.binance.com">
        <NavsIconWrap justify="center" align="center">
          <Icon type="labs" size={24} color="#F0B90B" />
        </NavsIconWrap>
        <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
          <NavsItemTitle>Labs</NavsItemTitle>
          <NavsItemDesc>{getLabel('exchange-header-labs', props.i18n)}</NavsItemDesc>
        </FlexBox>
      </NavsItem>

      <NavsItem id="exchange-header-launchpad" target="_blank" href="https://launchpad.binance.com">
        <NavsIconWrap justify="center" align="center">
          <Icon type="launchpad" size={20} color="#F0B90B" />
        </NavsIconWrap>
        <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
          <NavsItemTitle>Launchpad</NavsItemTitle>
          <NavsItemDesc>{getLabel('exchange-header-launchpad', props.i18n)}</NavsItemDesc>
        </FlexBox>
      </NavsItem>

      <NavsItem id="exchange-header-research" target="_blank" href="https://research.binance.com">
        <NavsIconWrap justify="center" align="center">
          <Icon type="research" size={24} color="#F0B90B" />
        </NavsIconWrap>
        <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
          <NavsItemTitle>Research</NavsItemTitle>
          <NavsItemDesc>{getLabel('exchange-header-research', props.i18n)}</NavsItemDesc>
        </FlexBox>
      </NavsItem>

      <NavsItem id="exchange-header-trustWallet" target="_blank" href="https://trustwalletapp.com">
        <NavsIconWrap2 justify="center" align="center">
          <Icon type="trust-wallet" size={24} color="#3274BA" />
        </NavsIconWrap2>
        <FlexBox margin="5px 0 5px 15px" padding="10px 0 0 0" direction="column">
          <NavsItemTitle>Trust Wallet</NavsItemTitle>
          <NavsItemDesc>{getLabel('exchange-header-trustWallet', props.i18n)}</NavsItemDesc>
        </FlexBox>
      </NavsItem>
    </NavsBox>
  </Dropdown>
);

LeftMenu.propTypes = {
  ...sharedPropTypes,
  selectedPair: PropTypes.string,
};
LeftMenu.defaultProps = {
  ...defaultProps,
  selectedPair: 'BTC_USDT',
};

const mapStateToProps = ({
  isLoggedIn, userInfo, selectedPair, userPreferredCurrency,
}) => ({
  isLoggedIn,
  userInfo,
  selectedPair,
  userPreferredCurrency,
});

const mapDispatchToProps = {
  getUserBtcValuation,
};

export default
@withI18n
@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps
)
class Header extends PureComponent {
  static propTypes = {
    isLoggedIn: PropTypes.bool,
    i18n: PropTypes.object,
    locale: PropTypes.string.isRequired,
    router: PropTypes.object,
    userInfo: PropTypes.object,
    selectedPair: PropTypes.string,
    getUserBtcValuation: PropTypes.func,
    showScaleAnimation: PropTypes.bool,
    userPreferredCurrency: PropTypes.object,
    isHideHeadLangSeclet: PropTypes.bool,
  };

  static defaultProps = {
    i18n: {},
    router: { asPath: '/' },
    userInfo: {},
    selectedPair: 'BTC_USDT',
    showScaleAnimation: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      // localeMenuPopped: false,
      googleTranslateMenuPopped: false,
      modeMenuPopped: false,
      userMenuOpen: false,
      supportMenuPopped: false,
      moreMenuPopped: false,
      walletMenuPopped: false,
      USDMenuPopped: false,
      leftMenuPopped: false,
      isShowGoogleTranslate: props.locale !== 'cn',
      scrollScale: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll);
    if (document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop >= 8) {
      this.setState({ scrollScale: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isLoggedIn && this.props.isLoggedIn) {
      this._getUserTotalAsset();
    }

    if (CHAT_SHOW_FLAG) {
      // set chat user data
      const timer = setInterval(() => {
        this._setLocalStorage(timer);
      }, 2000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll);
  }

  static getDerivedStateFromProps({ locale }) {
    return {
      isShowGoogleTranslate: locale !== 'cn',
    };
  }

  _setLocalStorage = timer => {
    // set chat user data
    const { userInfo } = this.props;
    if (userInfo && userInfo.email) {
      const chatUserData = {
        email: userInfo.email,
        id: userInfo.userId,
      };
      localStorage.setItem('CHAT_U_DATA', JSON.stringify(chatUserData));
      if (timer) clearInterval(timer);
      CHAT_SHOW_FLAG = false;
    } else {
      if (localStorage.getItem('CHAT_U_DATA')) localStorage.removeItem('CHAT_U_DATA');
      if (timer) clearInterval(timer);
    }
  };

  _handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    const { scrollScale } = this.state;
    if (scrollTop >= 8) {
      !scrollScale && this.setState({ scrollScale: true });
    } else {
      scrollScale && this.setState({ scrollScale: false });
    }
  };

  _getLocaleLink = locale => {
    const { router } = this.props;
    const matcher = /\/[a-z]{0,2}(\/|$)/;
    // does current route not contain locale? then go home
    if (!matcher.test(router.asPath)) {
      return prefixLink(`/${locale}`);
    }
    // current route contains locale, replace it
    return router.asPath.replace(matcher, `/${locale}/`).replace('//', '/');
  };

  _getLoginLinkHref = () => getLoginUrl(this.props.locale);

  _popUpGoogleTranslateMenu = (bool, e) => {
    if (e && e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
    const { locale } = this.props;
    if (!window.google || !window.google.translate || !window.google.translate.TranslateElement) {
      alert('Sorry, Google Translate is not available.');
      return;
    }

    new window.google.translate.TranslateElement( // eslint-disable-line
      {
        pageLanguage: locale,
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
      },
      'google_translate_element'
    );
    this.setState({ googleTranslateMenuPopped: bool });
    track(GOOGLE_TRANSLATOR_DOWN, { locale });
  };

  _popDownGoogleTranslateMenu = () => {
    this.setState({ googleTranslateMenuPopped: false });
  };

  _popUpModeMenu = (bool = false) => {
    this.setState({ modeMenuPopped: !!bool });
  };

  _popUpUserMenu = (bool = false) => {
    this.setState({ userMenuOpen: !!bool });
  };

  _popUpSupportMenu = (bool = false) => {
    this.setState({ supportMenuPopped: !!bool });
  };

  _popUpMoreMenu = (bool = false) => {
    this.setState({ moreMenuPopped: !!bool });
  };

  _popUpWalletMenu = (bool = false) => {
    this.setState({ walletMenuPopped: !!bool });
  };

  _popUpUSDMenu = (bool = false) => {
    this.setState({ USDMenuPopped: !!bool });
  };

  _popUpLeftMenu = (bool = false) => {
    this.setState({ leftMenuPopped: !!bool });
  };

  _getUserTotalAsset = async () => {
    this.props.getUserBtcValuation();
  };

  _onLegacyClick = () => {
    eraseCookie('canary');
    createCookie('canary', 'legacy', 1, true);
  };

  _renderUserMenu = () => {
    const {
      i18n, locale, isLoggedIn, userInfo, userPreferredCurrency,
    } = this.props;
    if (is.undefined(isLoggedIn)) {
      return null;
    }
    const {
      // localeMenuPopped,
      userMenuOpen,
      supportMenuPopped,
      moreMenuPopped,
      walletMenuPopped,
      googleTranslateMenuPopped,
      isShowGoogleTranslate,
      USDMenuPopped,
    } = this.state;
    const currencyName = getNativeCurrency(userPreferredCurrency);
    return (
      <HeaderNav justify="flex-end">
        {isLoggedIn ? (
          <HeaderNavItem
            role="menu"
            aria-expanded={walletMenuPopped}
            onFocus={() => this._popUpWalletMenu(true)}
            onMouseEnter={() => this._popUpWalletMenu(true)}
            onBlur={this._popUpWalletMenu}
          >
            <div>
              <HeadLink>{getLabel('exchange-nav-wallet', i18n)}</HeadLink>
              <ImgArrow src={require('./arrow.svg')} alt="wallet" draggable={false} />
            </div>
            <WalletMenu
              i18n={i18n}
              locale={locale}
              hide={!walletMenuPopped}
              onMouseLeave={this._popUpWalletMenu}
            />
          </HeaderNavItem>
        ) : null}
        <HeaderNavItem
          role="menu"
          aria-expanded={supportMenuPopped}
          onFocus={() => this._popUpSupportMenu(true)}
          onMouseEnter={() => this._popUpSupportMenu(true)}
          onBlur={this._popUpSupportMenu}
        >
          <div>
            <HeadLink>{getLabel('exchange-header-support', i18n)}</HeadLink>
            <ImgArrow src={require('./arrow.svg')} alt="Support" draggable={false} />
          </div>
          <SupportMenu
            i18n={i18n}
            locale={locale}
            hide={!supportMenuPopped}
            onMouseLeave={this._popUpSupportMenu}
            isLoggedIn={isLoggedIn}
          />
        </HeaderNavItem>
        <HeaderNavItem
          role="menu"
          aria-expanded={moreMenuPopped}
          onFocus={() => this._popUpMoreMenu(true)}
          onMouseEnter={() => this._popUpMoreMenu(true)}
          onBlur={this._popUpMoreMenu}
        >
          <div>
            <HeadLink>{getLabel('exchange-header-moreManagement', i18n)}</HeadLink>
            <ImgArrow src={require('./arrow.svg')} alt="More" draggable={false} />
          </div>
          <MoreMenu
            i18n={i18n}
            locale={locale}
            hide={!moreMenuPopped}
            onMouseLeave={this._popUpMoreMenu}
            isLoggedIn={isLoggedIn}
          />
        </HeaderNavItem>

        {!isLoggedIn ? (
          <NavLiLogin disabled={true} className="nav-item-identification">
            <HeadLink href={this._getLoginLinkHref()} id="exchange-header-signIn">
              {getLabel('exchange-login-signIn', i18n)}
            </HeadLink>
            {ENABLE_REGISTER && (
              <Link route={REGISTER_URL.replace('%locale', locale)}>
                <HeaderPrimaryButton id="exchange-header-register" type="primary">
                  {getLabel('exchange-register-Register', i18n)}
                </HeaderPrimaryButton>
              </Link>
            )}
          </NavLiLogin>
        ) : null}
        {isLoggedIn ? (
          <HeaderNavItem
            role="menu"
            aria-expanded={userMenuOpen}
            onFocus={() => this._popUpUserMenu(true)}
            onMouseEnter={() => this._popUpUserMenu(true)}
            onBlur={this._popUpUserMenu}
          >
            <LoggedInUser onMouseEnter={this._getUserTotalAsset}>
              <UserAvatar text={userInfo?.email?.substr(0, 2)} shouldArrow={true} />
            </LoggedInUser>
            <UserMenu hide={!userMenuOpen} onMouseLeave={this._popUpUserMenu} logout={Logout} />
          </HeaderNavItem>
        ) : null}
        <HeaderNavItemCurrency
          role="menu"
          aria-expanded={USDMenuPopped}
          onFocus={() => this._popUpUSDMenu(true)}
          onMouseEnter={() => this._popUpUSDMenu(true)}
          onBlur={this._popUpUSDMenu}
        >
          <span className="currency">
            <RateIcon type={currencyName?.toLowerCase()} />
            <HeadLink>{currencyName}</HeadLink>
            &nbsp;
            <ImgArrow src={require('./arrow.svg')} alt="USD" draggable={false} />
          </span>
          <USDMenu
            i18n={i18n}
            locale={locale}
            hide={!USDMenuPopped}
            onMouseLeave={this._popUpUSDMenu}
          />
        </HeaderNavItemCurrency>
        <a
          className="oldSite"
          id="legacyEntry"
          href={`https://www.binance.com/${locale}?canary=legacy`}
          target="_self"
          rel="noopener noreferrer"
          onClick={this._onLegacyClick}
        >
          {getLabel('exchange-header-OldSite', i18n)}
        </a>
        {false && isShowGoogleTranslate && (
          <HeaderNavItem
            role="menu"
            aria-expanded={googleTranslateMenuPopped}
            onFocus={() => this._popUpGoogleTranslateMenu(true)}
            onMouseOver={() => this._popUpGoogleTranslateMenu(true)}
            onClick={e => this._popUpGoogleTranslateMenu(true, e)}
            onBlur={this._popUpGoogleTranslateMenu}
            className="trunk"
          >
            <span>
              <img src={require('./googleFY.png')} alt="google translate" />
            </span>
            <GoogleTranslateBox isShow={googleTranslateMenuPopped}>
              <h3>{i18n['Website Translator'] || 'Website Translator'}</h3>
              <div id="google_translate_element" />
              <p>
                Translations by Google is provided for
                <br />
                convenience and is not verified contextually.
                <br />
                Please refer to original for accuracy.
              </p>
            </GoogleTranslateBox>
          </HeaderNavItem>
        )}
      </HeaderNav>
    );
  };

  render() {
    const {
      i18n,
      locale,
      selectedPair,
      showScaleAnimation,
      router: {
        query: { symbol },
      },
      isHideHeadLangSeclet,
    } = this.props;
    const { modeMenuPopped, leftMenuPopped, scrollScale } = this.state;
    const pair = symbol || selectedPair;
    return (
      <StyledHeader
        justify="space-between"
        showScaleAnimation={showScaleAnimation}
        isHideHeadLangSeclet={isHideHeadLangSeclet}
        scrollScale={scrollScale}
      >
        <HeaderNavWrapper scrollScale={scrollScale} showScaleAnimation={showScaleAnimation}>
          <HeaderNav as="ul">
            <HeaderNavItemScale
              className="logo-item"
              scrollScale={scrollScale}
              showScaleAnimation={showScaleAnimation}
            >
              <Logo locale={locale} />
            </HeaderNavItemScale>
            <HeaderNavItem
              aria-expanded={leftMenuPopped}
              onFocus={() => this._popUpLeftMenu(true)}
              onMouseEnter={() => this._popUpLeftMenu(true)}
              onBlur={this._popUpLeftMenu}
            >
              <Icon type="more-products" size={14} />
              <LeftMenu
                i18n={i18n}
                locale={locale}
                selectedPair={selectedPair}
                hide={!leftMenuPopped}
                onMouseLeave={this._popUpLeftMenu}
              />
            </HeaderNavItem>
            <RelativeHeaderNavItem
              role="menu"
              aria-expanded={modeMenuPopped}
              onFocus={() => this._popUpModeMenu(true)}
              onMouseEnter={() => this._popUpModeMenu(true)}
              onBlur={this._popUpModeMenu}
            >
              <div>
                <HeadLink route={prefixLink(`/${locale}`)} prefetch={true}>
                  {getLabel('exchange-header-Exchange', i18n)}
                </HeadLink>
                <ImgArrow src={require('./arrow.svg')} alt="Exchange" draggable={false} />
              </div>
              <ModeMenu
                i18n={i18n}
                locale={locale}
                selectedPair={pair}
                hide={!modeMenuPopped}
                onMouseLeave={this._popUpModeMenu}
              />
            </RelativeHeaderNavItem>

            <HeaderNavItem>
              <HeadLink href={prefixLink(`/${locale}/markets`)} id="exchange-header-markets">
                {getLabel('exchange-home-tableMarkets', i18n)}
              </HeadLink>
            </HeaderNavItem>
          </HeaderNav>
          {this._renderUserMenu()}
        </HeaderNavWrapper>
      </StyledHeader>
    );
  }
}
